import script from "./RbSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./RbSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./RbSnackbar.vue?vue&type=style&index=0&id=d2214ac4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2214ac4"]])

export default __exports__